import { AllowReadonly } from '@feedyou/utils'

export const toSelectOption = (value: string, label = value) => ({ value, label })

export type PossibleOptionLabel = string | JSX.Element
export type PossibleOptionValues = string | boolean | number

export type Option<
  V extends PossibleOptionValues = string,
  L extends PossibleOptionLabel = string
> = {
  label: L
  value: V
  __isNew__?: boolean
  data?: any
  dataTest?: string
}

export const getOptionByValue = <V extends PossibleOptionValues = string>(
  options: AllowReadonly<Option<V>[]>,
  value: V
): Option<V> => {
  return options.find(option => option.value === value)!
}

export const injectOption = <O extends Option>(options: O[], option?: O | null): O[] => {
  if (!option) {
    return options
  }

  return [...options, option]
}

export const doOptionsContainValue = (
  options: Option[],
  selectedOptionValue: string | null | undefined
): boolean => {
  if (!selectedOptionValue) {
    return false
  }

  return options.some(option => option.value === selectedOptionValue)
}
